import vMenu from '@/common/sideBar/index.vue' //侧边栏

export default {
	name: 'submitSuccess',
	components: { //注册组件
		vMenu, //侧边栏

	},
	data() {
		return {

		};
	},
	computed: {},
	filters: {},
	methods: {
		//获取页面高度
		getHeightFn() {
			let content = document.getElementById('content').offsetHeight;
			let nav = document.getElementById('nav');
			nav.style.height = content + "px";
		},
        goFinancingProgress() { //查看融资进度
			this.$router.push({ //跳转提交成功
				name: 'applyManageInfo',
			})
		},

	},
	created() {},
	mounted() {
		this.getHeightFn();
	},
	activated() {}
}